export const ADD_NEW_HIGHLIGHT = `mutation ($name: String!, $icon: String!) {
    add_new_highlight(name: $name, icon: $icon){
      message
    }
  }
`;

export const ACTIVATE_HIGHLIGHT = `mutation ($id : String!) {
    activate_highlight(_id: $id){
      message
    }
  }
`;

export const LIST_ALL_HIGHLIGHTS = `query ($pageSize: Int, $pageNumber: Int) {
    list_all_highlights(page_size: $pageSize, page_number: $pageNumber){
      message
      data {
        _id
        name
        icon
        is_active
      }
      hasMore
    }
  }
`;

export const ADD_NEW_FACILITY = `mutation ($name: String!, $icon: String!) {
    add_new_facility(name: $name, icon: $icon){
      message
    }
  }
`;


export const LIST_ALL_FACILITIES = `query ($pageSize: Int, $pageNumber: Int) {
    list_all_facilities(page_size: $pageSize, page_number: $pageNumber){
      message
      data {
        _id
        name
        icon
        is_active
      }
      hasMore   
    }
  }
`;

export const LIST_ALL_RATES = `query ($pageSize: Int, $pageNumber: Int, $rateType: String, $roomtypeId: String, $startDate: Int, $endDate: Int ) {
  list_all_rates(page_size: $pageSize, page_number: $pageNumber, rate_type: $rateType, roomtype_id: $roomtypeId, start_date: $startDate, end_date: $endDate){
    message
    data {
      _id
      current_rate
      roomtype {
        name
        description
      }
    }
    hasMore
  }
}`;

export const ADD_NEW_RATE = `mutation ($roomId: String, $roomtypeId: String, $normalRate: Float, $offers: [add_new_rate_offers]) {
  add_new_rate(room_id: $roomId, roomtype_id: $roomtypeId, normal_rate: $normalRate, offers: $offers){
    message
  }
}`;

export const UPLOAD_FILE = `mutation ($file: String!, $fileType: String) {
  upload_file(file: $file, file_type: $fileType){
    message
    url
  }
}`;

export const CHANGE_HOTEL_PASSWORD = `mutation ($password: String!) {
  change_hotel_password(password: $password){
    message
  }
}`;

export const LIST_HOTEL_NOTIFICATIONS = `query {
  get_hotel_notifications {
    message
    data {
      booking_id
      checkin_date
      name
      email
      guest_mobile
      guest_phone
      paid_amount
      unpaid_amount
      booking_from
    }
  }
}`;

export const ADD_NEW_COUPON = `mutation ($coupon_name: String!, $discount_value: Float!, $check_in_date: String!, $check_out_date: String!, $hotel_id: String!) {   
  add_new_coupon(
    coupon_name: $coupon_name,
    discount_value: $discount_value,
    check_in_date: $check_in_date,
    check_out_date: $check_out_date,
    hotel_id: $hotel_id,
  ) {
    message
  }
}
`;

export const LIST_ALL_COUPONS = `query ($page_size: Int, $page_number: Int) {
  list_all_coupons(page_size: $page_size, page_number: $page_number) {
    message
    data {
      _id
      coupon_name
      coupon_code
      active
      discount_value
      redeem_count
      check_in_date
      check_out_date
    }
    hasMore
    totalCount
  }
}`;

export const UPDATE_COUPON = `
  mutation UpdateCoupon($coupon_id: String!, $check_out_date: String!) {
    update_coupon(coupon_id: $coupon_id, check_out_date: $check_out_date) {
      message
      updatedCoupon {
        _id
        check_out_date
      }
    }
  }
`;



